$(function () {
    // Initialize reset button
    $("#resetButton").on("click", function () {
        puritanLawn.viewModel.reset();
    });

    // Initialize reset button
    $("#applyButton").on("click", function () {
        puritanLawn.viewModel.apply();
    });
});

function initViewModel(model) {
    var applicableTagQueryKey = 'applicableTagIds';

    function buildUrlWithApplicableTags(selectedTagIds) {
        var path = window.location.pathname || puritanLawn.viewModel.url || model.url || '';
        var params = new URLSearchParams(window.location.search || '');

        // Preserve existing query params (e.g., productTypeIds), replace only applicableTagIds.
        params.delete(applicableTagQueryKey);

        for (var i = 0; i < selectedTagIds.length; i++) {
            params.append(applicableTagQueryKey, selectedTagIds[i]);
        }

        var query = params.toString();
        return query ? (path + '?' + query) : path;
    }

    // Instantiate view model
    var viewModel = {
        url: model.url,
        reset: () => {
            window.location.href = buildUrlWithApplicableTags([]);
        },
        apply: () => {
            var applicableTagIds = $("input[name='applicableTagIds']:checked").map(function () {
                return this.value;
            }).get();
            var url = buildUrlWithApplicableTags(applicableTagIds);

            window.location.href = url;
        }
    };

    return viewModel;
}